const requireSelect = { required: true, message: "请选择" };
// 邮箱格式校验
const validateEmail = (rule, val, callback) => {
  const emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^this.$lodash.`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  if (val && !emailReg.test(val)) {
    callback(new Error("请输入正确邮箱"));
  }
  callback()
};
// 邮箱格式校验(已存在邮箱后缀)
const validateEmail2 = (rule, val, callback) => {
  const emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^this.$lodash.`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  if (val !== "" && !emailReg.test(`${val}@chailease.com.cn`)) {
    callback(new Error("请输入正确邮箱"));
  }
  callback()
};
// 金额校验 仅整数，大于0
const validateMoney = (rule, val, callback) => {
  const numReg = /^\d+$/;
  if ((val || val === 0) && !numReg.test(val)) {
    callback(new Error("请输入大于0的整数数字"));
  }
  callback()
};
// 手机号校验
// const validatePhone = (rule, val, callback) => {
//   const phoneReg = /^\d+$/;
//   if (val !== "" && !numReg.test(val)) {
//     callback(new Error("请输入正确的手机号"))
//   }
//   callback()
// };
// 座机号校验
const validateTel = (rule, val, callback) => {
  const telReg = /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/;
  if (val !== "" && !telReg.test(val)) {
    callback(new Error("请输入正确的电话号码"));
  }
  callback()
};
// 身份证号校验
export const validateIdentityId = (rule, val, callback) => {
  const numReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
  if (val !== "" && !numReg.test(val)) {
    callback(new Error("请输入正确的身份证号码"));
  }
  callback()
};
// 港澳台通行证校验
export const validateExitEntryPermit = (rule, val, callback) => {
  const numReg = /(^8)([A-Za-z0-9]{17}$)/;
  if (val !== "" && !numReg.test(val)) {
    callback(new Error("请输入正确的通行证号码"));
  }
  callback()
};
// 护照校验
export const validatePassport = (rule, val, callback) => {
  const numReg = /^[a-zA-Z0-9]{8,15}$/;
  if (val !== "" && !numReg.test(val)) {
    callback(new Error("请输入正确的护照号码"));
  }
  callback()
};
// 税号校验
const validateTaxNumber = (rule, val, callback) => {
  const numReg = /[0-9A-HJ-NPQRTUWXY]{8}-[0-9A-HJ-NPQRTUWXY]{1}$/;
  const taxReg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
  if (val !== "" && !numReg.test(val) && !taxReg.test(val)) {
    callback(new Error("客户名称为企业，请输入正确的税号"));
  }
  callback()
};
// 税号校验
const validateTaxNumber2 = (rule, val, callback) => {
  const numReg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
  if (val !== "" && !numReg.test(val)) {
    callback(new Error("请输入正确的纳税人识别号"));
  }
  callback()
};
// 证件号校验
const validateIdNumber = (rule, val, callback) => {
  const identityIdReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  const permitReg = /(^8)([A-Za-z0-9]{17}$)/;
  const passpotReg = /^[a-zA-Z0-9]{8,15}$/;
  const numReg = /[0-9A-HJ-NPQRTUWXY]{8}-[0-9A-HJ-NPQRTUWXY]{1}$/; // 组织机构代码
  const taxReg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
  
  if (
    val !== "" &&
    !identityIdReg.test(val) &&
    !permitReg.test(val) &&
    !passpotReg.test(val) &&
    !numReg.test(val) &&
    !taxReg.test(val)
  ) {
    callback(new Error("请输入正确的证件号"));
  }
  callback()
};
// 邮寄地址校验
const validateSendAddress = (rule, val, callback) => {
  const emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^this.$lodash.`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  if (val && emailReg.test(val)) {
    callback(new Error("邮寄地址请勿输入邮箱地址"));
  }
  callback()
};
// 银行卡号（10到30位, 覆盖对公/私账户, 参考微信支付）
// const validateAccount = (rule, val, callback) => {
//   const accountReg = /^[0-9]\d{9,29}$/;
//   if (val !== "" && !accountReg.test(val)) {
//     callback(new Error("请输入正确的开户行账号"));
//   }
//   callback();
// };
// 员工编号长度限制
const validatemenberNum = (rule, val, callback) => {
  const accountReg = /^.{0,19}$/;
  if (val !== "" && !accountReg.test(val)) {
    callback(new Error("请输入20位以内员工编号"));
  }
  callback();
};
// 校验存在数字
const validExitNumber = (rule, val, callback) => {
  let reg = /\d/g;
  if (val !== "" && reg.test(val)) {
    callback(new Error("请勿输入数字"));
  }
  callback();
};

export const REQUIRERULE = {
  selectRequire: { rules: [requireSelect] },
  wenEmail: {
    rules: [
      { required: true, message: "请输入文审邮箱" },
      {
        validator: validateEmail2,
      },
    ],
  },
  receiveEmail: {
    rules: [
      { required: true, message: "请输入接收保单邮箱" },
      {
        validator: validateEmail,
      },
    ],
  },
  yeEmail: {
    rules: [
      { required: true, message: "请输入业务员邮箱" },
      {
        validator: validateEmail2,
      },
    ],
  },
  menberNum: {
    rules: [
      { required: true, message: "请输入员工编号" },
      {
        validator: validatemenberNum,
      },
    ],
  },
  holderName: {
    rules: [{ required: true, message: "请输入客户名称" }],
  },
  taxIdNumber: {
    rules: [
      { required: true, message: "请输入税号/证件号" },
      {
        validator: validateTaxNumber,
      },
    ],
  },
  idNumber: {
    rules: [
      { required: true, message: "请输入税号/证件号" },
      { validator: validateIdNumber },
    ],
  },
  tickets: {
    rules: [
      { required: true, message: "请输入汇款金额" },
      { validator: validateMoney },
    ],
  },
  invoiceStart: {
    rules: [{ required: true, message: "请选择发票抬头" }],
  },
  invoiceSbh: {
    rules: [
      { required: true, message: "请输入纳税人识别号" },
      {
        validator: validateTaxNumber2,
      },
    ],
  },
  invoiceKhh: {
    rules: [{ required: true, message: "请输入开户行名称" }],
  },
  invoiceNumber: {
    rules: [
      { required: true, message: "请输入开户行账号" },
      // { validator: validateAccount },
    ],
  },
  invoiceKpdz: {
    rules: [{ required: true, message: "请输入开票地址" }],
  },
  invoiceKpdh: {
    rules: [{ required: true, message: "请输入开票电话" }],
  },
  invoiceLxr: {
    rules: [
      { required: true, message: "请输入联系人" },
      { validator: validExitNumber }
    ],
  },
  invoiceLxdh: {
    rules: [
      { required: true, message: "请输入联系人手机号" },
      { validator: validateTel },
    ],
  },
  invoiceYjdz: {
    rules: [
      { required: true, message: "请输入邮寄地址" },
      { validator: validateSendAddress },
    ],
  },
};
export function rentMoney(name) {
  const message = `请输入${name}`;
  return {
    rules: [{ required: true, message }, { validator: validateMoney }],
  };
}
export const CAICHANRULE = {

}
export const CHENGZURULE = {
    identity: [
        
    ]
}